import React from 'react'

import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { useOrderTravellers } from 'tripPlanner/hooks/api'

type Props = {
  orderId: string
}

function OrderTravellers(props: Props) {
  const { data: orderTravellers, status: loadingTravellerStatus } =
    useOrderTravellers(props.orderId)

  return (
    <>
      {loadingTravellerStatus === 'loading' && <LoadingIndicator inline />}
      {loadingTravellerStatus === 'success' &&
        orderTravellers.map((traveller, index) => (
          <div key={traveller.traveller_id}>
            <BodyText variant="medium" weight="semi-bold">
              Traveller {index + 1}
            </BodyText>
            <BodyText variant="large">{`${traveller.first_name} ${traveller.last_name}`}</BodyText>
            <BodyText variant="medium" colour="neutral-two">
              {traveller.booking_number}
            </BodyText>
          </div>
        ))}
    </>
  )
}

export default OrderTravellers
